import React from "react";
import { Button } from "components/common/buttons/Button";

interface DetailedLevelBudgetGridProps {
  path: {
    name: string;
    action: () => void;
  }[];
}

export const DetailedBudgetBreadcrumbs: React.FC<DetailedLevelBudgetGridProps> = ({ path }) => {
  return (
    <div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-1">
      {path.map((pathItem, index) => {
        const isLast = index === path.length - 1;
        return (
          <React.Fragment key={index}>
            {isLast ? (
              <div aria-current="page" className="uppercase">
                {pathItem.name}
              </div>
            ) : (
              <Button
                type="button"
                color="brand"
                size="xs"
                onClick={() => pathItem.action()}
                className="uppercase"
              >
                {pathItem.name}
              </Button>
            )}
            {!isLast ? <div className="text-muted-foreground"> / </div> : null}
          </React.Fragment>
        );
      })}
    </div>
  );
};
